
import {Component, Prop, Vue} from "vue-property-decorator";
import $ from "jquery";
import "bootstrap/js/dist/modal";

@Component
export default class DownloadGumroad extends Vue {
  @Prop() windowsLink;
  @Prop() macosLink;
  @Prop() linuxLink;
  @Prop() zipLink;
  private gumroadLink = '';
  private gumroadProduct = '';

  private showGumroadModal(e) {
    this.gumroadLink = e.target.getAttribute("href");
    this.gumroadProduct = e.target.getAttribute("data-product");
    $("#gumroadModal").modal({});
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }

  public mounted() {
    this.windowsLink = "https://ganttproject.biz/checkout#win";
    this.macosLink = "https://ganttproject.biz/checkout#mac";
    this.linuxLink = "https://ganttproject.biz/checkout#lin";
    this.zipLink = "https://ganttproject.biz/checkout#zip";
    //$("#gumroadModal").appendTo($("body"));
    //$(".btn-gumroad").on("click", (e) => this.showGumroadModal(e));
  }
}
